import type { CreateTaxCodesPayload, CreateTaxCodesResponse } from './types';

import { ENDPOINT } from '~/constants/endpoints';

import { vestigasApi } from '~/services/kyClient';

import {
  zodCreateTaxCodesPayloadSchema,
  zodCreateTaxCodesResponseSchema,
} from './validations';

/**
 * Creates tax codes for the selected companies or the whole company account.
 *
 * @param payload - Tax-code values and their company scope.
 * @returns The tax codes created for the resolved companies.
 * @see https://app.dev.vestigas.com/redoc#tag/Tax-Codes
 */
export const createTaxCodes = async (payload: CreateTaxCodesPayload) =>
  vestigasApi
    .post(ENDPOINT.TAX_CODE.CREATE(), {
      json: payload,
      validate: {
        body: zodCreateTaxCodesPayloadSchema,
        response: zodCreateTaxCodesResponseSchema,
      },
    })
    .json<CreateTaxCodesResponse>();
